import React from 'react'

/*
import img_01 from './static/img/01软件支持.png'
import img_02 from './static/img/02定期更新.png'
import img_03 from './static/img/03高效制图.png'
import img_04 from './static/img/04版本转化.png'
import img_05 from './static/img/05快捷登录.png'
import img_06 from './static/img/06异常修复.png'
import img_banner3 from './static/img/banner3.png'
import img_CG from './static/img/CG Magic Banner.jpg'
import img_q from './static/img/q群二维码.png'
import img_dibu_qq from './static/img/底部qq.png'
import img_dibu_pho from './static/img/底部电话.png'
import img_dibu_xian from './static/img/底部线.png'
import img_dibu_email from './static/img/底部邮箱.png'
import img_weixin from './static/img/微信二维码.png'
*/

import img_01 from './static/img_mobile/u21.png'
import img_02 from './static/img_mobile/u22.png'
import img_03 from './static/img_mobile/u23.png'
import img_04 from './static/img_mobile/u24.png'
import img_05 from './static/img_mobile/u25.png'
import img_06 from './static/img_mobile/u26.png'
import img_banner3 from './static/img_mobile/u54.png'
import img_CG from './static/img_mobile/u38.jpg'
import img_q from './static/img_mobile/u12.svg'
import img_dibu_qq from './static/img_mobile/u18.png'
import img_dibu_pho from './static/img_mobile/u16.png'
import img_dibu_xian from './static/img_mobile/u11.svg'
import img_dibu_email from './static/img_mobile/u17.svg'
import img_weixin from './static/img_mobile/u13.svg'

import img_u35 from  './static/img_mobile/u35.svg'
import img_u46 from './static/img_mobile/u46.svg'
import img_u44 from './static/img_mobile/u44.png'
import img_u43 from './static/img_mobile/u43.png'

import $ from 'jquery'
import './home_mobile.css';


class Home extends React.Component {

    show_dropdown = () => {
        if ($("#cgmobile_u47").css("display") ==="none"){
            $("#cgmobile_u47").css("display", "");//display属于css中的属性，而不属于该div的属性
            $("#cgmobile_u47").css("visibility", "visible");
        }else{
            $("#cgmobile_u47").css("display", "none");
            $("#cgmobile_u47").css("visibility", "hidden");
        }
    }

    render() {

        return(
            <div id="mobile_web_div">{/* 加1层div 用来区分 网页版/手机版 */}
                {/* 最上面 */}
                <div id="cgmobile_drop_down" style={{ top:'0px',width:'414px',backgroundColor:"#d9d9d9", position:'fixed',zIndex:'999',opacity:'0.8' }}>

                    <div style={{ height:'38px' }}>
                        {/*  (38-22)/2=8  */}
                        <img style={{ top:'8px',width:'101px',height:'22px',position:'relative',left:'-80px' }} className="cgmobile_img " src={img_u44} alt=""/>
                        &nbsp;&nbsp;
                        <span style={{ top:'8px',width:'80px', height:'22px',position:'relative',left:'-80px',color:'white'  }}>|</span>
                        &nbsp;&nbsp;
                        <img style={{ top:'8px',width:'80px', height:'22px',position:'relative',left:'-80px'  }} className="cgmobile_img " src={img_u43} alt=""/>
                        <img style={{ top:'8px',position:'relative',right:'-80px' }} className="cgmobile_img " src={img_u46} alt="" onClick={this.show_dropdown}/>
                    </div>

                    {/* 默认隐藏的下拉菜单  display:'none', visibility:'hidden', */}
                    <div id="cgmobile_u47" style={{  display:'none', visibility:'hidden', height:'858px', backgroundColor:'#ffffff',opacity:'1' }} onClick={this.show_dropdown} >
                        <a className="cgmobile_text_drop" href="#">首页</a>
                        <a className="cgmobile_text_drop" href="http://doc.maxplugin.com/1470931" style={{ top:'70px' }}>功能介绍</a>
                        <a className="cgmobile_text_drop" href="http://bbs.xrender.com" style={{ top:'100px' }}>社区</a>
                        <a className="cgmobile_text_drop" href="http://www.xrender.com" style={{ top:'130px' }}>免费渲</a>
                        {/*
                        <p className="cgmobile_text_drop" style={{ top:'160px' }}>注册</p>
                        */}
                    </div>
                </div>

                <div id='cgmobile_First'>
                    <img id="cgmobile_img_CG" src={img_CG} alt=""/>
                </div>

                <div id='cgmobile_Second'>
                    <div id="cgmobile_sec_div1">
                        <p style={{ fontSize:'28px',top:'20px',position:'relative',color:'#47537b' }}>特色功能</p>

                        <img id="cgmobile_img_u35" src={img_u35} alt=""/>
                        <p id="cgmobile_second_p1">Features of  CGMAGIC</p>

                        <div style={{ width:'394px',marginLeft:'auto',marginRight:'auto',position:'relative', top:'-30px'}}>
                            <span id="cgmobile_second_p2" className='cgmobile_text cgmobile_text_word_wrap'>作为魔宝团队倾力打造的次世代新品CG魔宝预设了非常丰富的功能集合：全版本转换，CAD导入，一键建模，灯光布景，</span><br/><br/>
                            <span id="cgmobile_second_p3" className='cgmobile_text cgmobile_text_word_wrap'>贴图材质设置，渲染参数设定等功能。用户仅通过一个设置面板中就可以满足所有功能，给你N个吹爆它的理由。</span>
                        </div>

                    </div>

                    <div id="cgmobile_sec_div2">

                        <div className="cgmobile_flex-container" style={{ top:'30px',position:'relative' }}>
                            {/* 因为每张图片的长宽都不一样,so,单独写 */}
                            <img style={{ width:'172px',height:'108px',position:'relative',marginLeft:'20px' }} src={img_01} alt=""/>
                            <img style={{ width:'152px',height:'108px',position:'relative',marginLeft:'50px' }} src={img_02} alt=""/>{/*  20+172+X+152+20=414  */}
                        </div>

                        <div className="cgmobile_flex-container" style={{ textAlign:'center', top:'40px',position:'relative' }}>
                            <div className="cgmobile_left_right_flex">
                                <p className="cgmobile_Subheading">软件支持</p>
                                <p className="cgmobile_Subheading_p">3ds Max2010 - 2021(Design)</p>
                                <p className="cgmobile_Subheading_p">支持VRay5与Corona6</p>
                            </div>

                            <div className="cgmobile_left_right_flex">
                                <p className="cgmobile_Subheading">定期更新</p>
                                <p className="cgmobile_Subheading_p">每月定期更新版本</p>
                                <p className="cgmobile_Subheading_p">持续为大家提供免费优质新功能</p>
                            </div>
                        </div>

                        <div className="cgmobile_flex-container" style={{ top:'100px',position:'relative' }}>
                            <img style={{ width:'172px',height:'114px',position:'relative',marginLeft:'20px' }} src={img_03} alt=""/>
                            <img style={{ width:'153px',height:'108px',position:'relative',marginLeft:'49px' }} src={img_04} alt=""/> {/* 20+172+x+153+20=414 */}
                        </div>

                        <div className="cgmobile_flex-container" style={{ textAlign:'center',top:'100px',position:'relative' }}>
                            <div className="cgmobile_left_right_flex">
                                <p className="cgmobile_Subheading">高效制图</p>
                                <p className="cgmobile_Subheading_p">一键优化、建模</p>
                                <p className="cgmobile_Subheading_p">给您从未体验的制图快感</p>
                            </div>

                            <div className="cgmobile_left_right_flex">
                                <p className="cgmobile_Subheading">版本转化</p>
                                <p className="cgmobile_Subheading_p">支持3ds max 2012-2021文件</p>
                                <p className="cgmobile_Subheading_p">一键转化，从此不求人</p>
                            </div>

                        </div>

                        <div className="cgmobile_flex-container" style={{ top:'160px',position:'relative' }}>
                            <img style={{ width:'172px',height:'127px',position:'relative',marginLeft:'20px' }} src={img_05} alt=""/>
                            <img style={{ width:'152px',height:'113px',position:'relative',marginLeft:'50px' }} src={img_06} alt=""/> {/* 20+172+X+152+20=414 */}
                        </div>

                        <div className="cgmobile_flex-container" style={{ textAlign:'center',top:'160px',position:'relative'  }}>
                            <div className="cgmobile_left_right_flex">
                                <p className="cgmobile_Subheading">快捷登录</p>
                                <p className="cgmobile_Subheading_p">登录式体验，解决传统插件脚本</p>
                                <p className="cgmobile_Subheading_p">丢失奔溃等问题</p>
                            </div>

                            <div className="cgmobile_left_right_flex">
                                <p className="cgmobile_Subheading">异常修复</p>
                                <p className="cgmobile_Subheading_p">跟3ds Max各种无法启动</p>
                                <p className="cgmobile_Subheading_p">异常报错 say goodbye</p>
                            </div>
                        </div>

                    </div>

                </div>

                <div id='cgmobile_Third'>
                    {/**/}
                    <img id="cgmobile_img_banner3" src={img_banner3} alt=""/>

                </div>

                <div id='cgmobile_Fifth'>

                    <div id='cgmobile_five_top' className="cgmobile_flex-container">

                        <div style={{ width:'170px',height:'200px',position:'relative',marginLeft:'20px', textAlign:'left' }}>

                            <a className='title_bottom' href="http://doc.maxplugin.com/1470931"><p style={{ position:'relative', top:'30px',fontSize:'19px',color:'#cccccc' }}>魔宝教程</p></a>
                            <a className='title_bottom' href="http://doc.maxplugin.com/1470931"><p style={{ position:'relative', top:'50px',fontSize:'13px',color:'#cccccc' }}>客户端使用</p></a>

                            {/*
                            <p style={{ position:'relative', top:'50px',fontSize:'13px',color:'#cccccc' }}>更新说明</p>
                            <p style={{ position:'relative', top:'50px',fontSize:'13px',color:'#cccccc' }}>免费试用</p>
                            */}

                        </div>

                        <div style={{ width:'244px',height:'200px',position:'relative',top:'10px' }}>{/* 414-170=244 */}
                            <div className="cgmobile_flex-container">
                                <img id="cgmobile_img_q" src={img_q} alt="" />
                                <img id="cgmobile_img_weixin" src={img_weixin} alt=""/>
                            </div>

                            <div id='cgmobile_right_buttom' style={{ textAlign:'left' }}>
                                <div id="cgmobile_five_grand_v1">
                                    <span className="cgmobile_text_contact">扫码加入QQ群</span>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <span className="cgmobile_text_contact">扫码关注微信</span>
                                </div>

                                <div>
                                    <img id="cgmobile_img_dibu_pho" src={img_dibu_pho} alt=""/>
                                    <span className="cgmobile_text_customer_service">4006-888-245</span>
                                </div>

                                <div>
                                    <img id="cgmobile_img_dibu_qq" src={img_dibu_qq} alt=""/>
                                    <span className="cgmobile_text_customer_service">客服: 3001188325</span>
                                </div>

                                <div>
                                    <img id="cgmobile_img_dibu_email" src={img_dibu_email} alt=""/>
                                    <span className="cgmobile_text_customer_service">CGtools@cudatec.com</span>
                                </div>
                            </div>
                        </div>
                    </div>


                    <img id="cgmobile_img_dibu_xian" src={img_dibu_xian} alt=""/>

                    <p style={{ fontSize:'12px', color:'#cccccc',marginTop:'10px' }}>©2021 江苏赞奇科技股份有限公司 丨 苏ICP备11007458号 版权所有</p>

                </div>

            </div>
        )
    }
}

export default Home;

